/**
 * Replacement for the keyboard number input that is shown for multi-part /
 * fill the gaps questions when in checking mode
 */

import React from 'react';
import IPropTypes from 'react-immutable-proptypes';

const CHECKING_LABELS_ORDERED = {
    exact: 'Must exactly match',
    equal: 'Any value equal to',
};

const CHECKING_LABELS_UNORDERED = {
    exact: 'Each exact value must be in a slot',
    equal: 'A value equal to each must be in a slot',
};

export class CheckingLabel extends React.Component {
    static displayName = 'CheckingLabel';

    static propTypes = {
        checkingModeMetadata: IPropTypes.map.isRequired,
    };

    render() {
        const { checkingModeMetadata } = this.props;

        const answers = checkingModeMetadata.get('answers');
        const answerComps = answers.map((answer, index) => (
            <div key={'answer' + index}>{answer}</div>
        ));
        const evalType = checkingModeMetadata.get('evalType');

        let label = '';
        if (evalType) {
            const answerStyle = checkingModeMetadata.get('answerStyle');

            if (answerStyle === 'ordered') {
                label = CHECKING_LABELS_ORDERED[checkingModeMetadata.get('evalType')];
                if (checkingModeMetadata.get('answers').size > 1) {
                    label += ' one of';
                }
                label += ':';
            } else {
                label = CHECKING_LABELS_UNORDERED[checkingModeMetadata.get('evalType')] + ':';
            }
        }

        return (
            <div className="number-input-checking-label">
                <div className="number-input-checking-label-title">{label}</div>
                <div className="number-input-checking-label-answers">{answerComps}</div>
            </div>
        );
    }
}
